import { render, staticRenderFns } from "./ErrorMessages.vue?vue&type=template&id=81197dfe&scoped=true"
import script from "./ErrorMessages.vue?vue&type=script&lang=js"
export * from "./ErrorMessages.vue?vue&type=script&lang=js"
import style0 from "./ErrorMessages.vue?vue&type=style&index=0&id=81197dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81197dfe",
  null
  
)

export default component.exports